import hcAxios, { AxiosResponse } from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'

export type TGetLimitAreaServiceService = TResponse<string[]>

export type TGetLimitAreaServiceParams = {
  scene: 1 | 2 // 不知道啥意思，1: resetPwd,login使用 2: 注册使用
}

export const getLimitAreaService = async (params: TGetLimitAreaServiceParams) => {
  return await hcAxios.get<TGetLimitAreaServiceService>('/hk-web/public/common/locales', { params })
}

// /public/get-web-config
export type TGetWebConfigService = TResponse<{
  version: string
  officialWebsites: string[]
  backupWebsites: string[]
}>

export const getWebConfigService = async () => {
  return await hcAxios.get<TGetWebConfigService>('/hk-web/public/get-web-config')
}
